import { derived, readable, type Readable } from "svelte/store";
import { chainStores, getDocumentAsStore, getSubCollectionAsStore } from "$lib/utils/firestore";
import { selectedOrgIdStore } from "$lib/stores/orgs";
import { querystring } from "svelte-spa-router";

/**
 * Store that gets the latest version from Firestore
 */
const latestReportFirestoreVersionStore: Readable<string | undefined> = chainStores(
  derived([selectedOrgIdStore], (all) => all),
  undefined,
  ([selectedOrgId]) => {
    if (!selectedOrgId) {
      return readable(undefined);
    }

    console.log("[latestReportFirestoreVersionStore] Selected Org ID:", selectedOrgId);

    return derived(
      [
        getSubCollectionAsStore(`organisations/${selectedOrgId}/security_findings`, {
          orderBy: [{ field: "modified", direction: "desc" }],
          limit: 1,
        }),
      ],
      ([result]) => {
        if (result.length && result.length > 0) {
          return (
            result[0].data.security_finding_reference?.security_finding_version || result[0].data.securityFindingVersion
          );
        }
      },
    );
  },
);

const versionFromUrlStore = readable<string | undefined>(undefined, (set) => {
  let lastVersion: string | undefined;
  const unsub = querystring.subscribe((querystring) => {
    const searchParams = new URLSearchParams(querystring);
    const version = searchParams.get("version");
    if (!!version && version !== lastVersion) {
      // We want to update the store when the URL param version changes
      set(version);
      lastVersion = version;
    }
  });
  return () => unsub();
});

/**
 * Latest Version store that combines both the URL param version (if present) and the latest Firestore version.
 * The URL param version takes precedence over the Firestore version when present.
 */
export const selectedReportVersionStore = derived(
  [versionFromUrlStore, latestReportFirestoreVersionStore],
  ([versionFromUrl, latestFirestoreVersion]) => {
    // URL param version takes precedence if present
    if (versionFromUrl) {
      console.log(`[selectedReportVersionStore] Using version from URL: ${versionFromUrl}`);
      return versionFromUrl;
    }

    console.log(`[selectedReportVersionStore] Using version from Firestore: ${latestFirestoreVersion}`);
    return latestFirestoreVersion;
  },
);
